import { render, staticRenderFns } from "./field-settings-modal.vue?vue&type=template&id=b0f282f2&scoped=true"
import script from "./field-settings-modal.vue?vue&type=script&lang=js"
export * from "./field-settings-modal.vue?vue&type=script&lang=js"
import style0 from "./field-settings-modal.vue?vue&type=style&index=0&id=b0f282f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0f282f2",
  null
  
)

export default component.exports